import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DocumentTypeService } from '../../core/services/document/document-type/document-type.service'

export type SupplierPortalDocumentScope = 'motorista' | 'veiculo'

export interface DocumentTypeOption {
  id: number
  descricao: string
}

// Descrições aceitas por escopo — o id numérico do TipoDoc pode mudar entre qa e prod,
// então a resolução é sempre pela descrição (via TipoDocumento/listall), nunca por id fixo.
export const ACCEPTED_DOCUMENT_DESCRIPTIONS: Record<SupplierPortalDocumentScope, string[]> = {
  motorista: ['cnh', 'antecedentes criminais'],
  veiculo: ['licenciamento', 'seguro'],
}

export function normalizeDocumentDescription(value: string): string {
  return (value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
}

export function loadAcceptedDocumentTypes(
  documentTypeService: DocumentTypeService,
  escopo: SupplierPortalDocumentScope,
): Observable<DocumentTypeOption[]> {
  const accepted = ACCEPTED_DOCUMENT_DESCRIPTIONS[escopo]
  return documentTypeService.listDocumentType().pipe(
    map((res: any) => {
      const all: DocumentTypeOption[] = res.data ?? []
      return all.filter((tipo) => accepted.includes(normalizeDocumentDescription(tipo.descricao)))
    }),
  )
}
